export default __webpack_public_path__ + "static/media/crwn-clothing.bf9f2952.jpg";